import React from 'react'
import useDynamicStore from '../../hooks/useDynamicStore'
import customLoginReducer from '../../store/custom-login/customLoginReducer'

import PageUi from '../ui/PageUi'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'

function CustomLoginPage({ children }: { children: React.ReactNode }) {
  useDynamicStore({ key: 'customLogin', reducer: customLoginReducer })
  const { globalFontFamily, globalFontWeight, globalFontStyle } =
    useCalculateTypography({})

  return (
    <PageUi
      fontFamily={globalFontFamily}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
    </PageUi>
  )
}

export default CustomLoginPage
